// extracted by mini-css-extract-plugin
export default {"resultWrapper":"kshAKDe21BMEddYhsMew","description":"F2EMWLq0SqQ98VW7sJgp","footer":"jOlgdQRXA3FdyUoMpwdm"};